module.exports = __webpack_public_path__ + "img/feaa7c3.png";